<template>
  <div class="background-loader" v-if="show">
    <div class="preloader" aria-busy="true" :aria-label="$t('application.messages.loading')" data-test="loading" role="progressbar"></div>
    <div class="message">{{ $t('application.messages.loading') }}<span class="ellipsis-anim"><span>.</span><span>.</span><span>.</span></span></div>
  </div>
</template>
<script>
import scroll from 'src/utils/scroll'
export default {
  computed: {
    show () {
      scroll.scrollToTop()
      return this.$store.state.tcLoader.show
    }
  }
}
</script>
<style scoped lang="scss">
  .ls-topbar:after {
    box-shadow: none;
  }
  .background-loader {
    display: block;
    opacity: 0.9!important;
    height: 100vh;
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
    background: #fff;
    left: 0;
    z-index: 9999;
    animation-duration: 0.3s;
    animation-name: fadeIn;
    animation-fill-mode: forwards;
    -webkit-animation-duration: 0.3s;
    -webkit-animation-name: fadeIn;
    -webkit-animation-fill-mode: forwards;
    -ms-animation-duration: 0.3s;
    -ms-animation-name: fadeInIE;
    -ms-animation-fill-mode: forwards;
    .preloader {
      vertical-align: middle;
      display: inline-block;
      position: absolute;
      top: 0;
      bottom: 0%;
      height: 40px;
      width: 40px;
      margin: auto;
      left: 0;
      right: 0;
      &:before {
        content: "";
        display: block;
        position: absolute;
        left: -1px;
        top: -1px;
        height: 100%;
        width: 100%;
        -webkit-animation: rotation 1s linear infinite;
                animation: rotation 1s linear infinite;
        border: 2px solid #c1c1c1!important;;
        border-top: 2px solid transparent!important;;
        border-radius: 100%;
      }
    }
    @media only screen and (min-width: 768px) {
      .preloader {
        height: 80px;
        width: 80px;
      }
      .preloader:before {
        left: -2px;
        top: -2px;
      }
    }
    @media only screen and (min-width: 1200px) {
      .preloader {
        height: 80px;
        width: 80px;
      }
    }
    @-webkit-keyframes rotation {
      from {
        -webkit-transform: rotate(0deg);
                transform: rotate(0deg);
      }
      to {
        -webkit-transform: rotate(359deg);
                transform: rotate(359deg);
      }
    }
    @keyframes rotation {
      from {
        -webkit-transform: rotate(0deg);
                transform: rotate(0deg);
      }
      to {
        -webkit-transform: rotate(359deg);
                transform: rotate(359deg);
      }
    }
    .message {
      text-align: center;
      position: relative;
      color: #929292;
      max-width: 280px;
      line-height: 20px;
      top: 58%;
      font-weight: 100;
      transform: translateY(-50%);
      margin: 0 auto;
    }
  }
  .ellipsis-anim {
    span {
      opacity: 0;
      -webkit-animation: ellipsis-dot 1s infinite;
      animation: ellipsis-dot 1s infinite;
      &:nth-child(1) {
        -webkit-animation-delay: 0.0s;
        animation-delay: 0.0s;
      }
      &:nth-child(2) {
        -webkit-animation-delay: 0.1s;
        animation-delay: 0.1s;
      }
      &:nth-child(3) {
        -webkit-animation-delay: 0.2s;
        animation-delay: 0.2s;
      }
    }
  }
  @-webkit-keyframes ellipsis-dot {
        0% { opacity: 0; }
       50% { opacity: 1; }
      100% { opacity: 0; }
  }

  @keyframes ellipsis-dot {
        0% { opacity: 0; }
       50% { opacity: 1; }
      100% { opacity: 0; }
  }
  @-webkit-keyframes fadeIn {
      0% { opacity: 0; }
      1% { opacity: 0; }
    100% { opacity: 0.9; }
  }

  @keyframes fadeInIE {
      0% { opacity: 0; }
      1% { opacity: 0; }
    100% { opacity: 0.9; }
  }

  @keyframes fadeIn {
      0% { opacity: 0; }
      1% { opacity: 0; }
    100% { opacity: 0.9; }
  }
</style>



// WEBPACK FOOTER //
// page-loader.vue?51da01a0